import { render, staticRenderFns } from "./ConfigViewSidebar.vue?vue&type=template&id=15a956e9&scoped=true&"
import script from "./ConfigViewSidebar.vue?vue&type=script&lang=js&"
export * from "./ConfigViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ConfigViewSidebar.vue?vue&type=style&index=0&id=15a956e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a956e9",
  null
  
)

export default component.exports